import Vue from 'vue'
import E from './builderComponents/events'
// import StepperPopover from './components/StepperPopover'
import SelectPopover from './builderComponents/SelectPopover'
import ListPopover from './builderComponents/ListPopover'
import OperatorPopover from './builderComponents/OperatorPopover'
import NotificationPopover from './builderComponents/NotificationPopover'
// import attributeTypes from '../../../views/workbench/config/attributeTypes'
// import PopoverBox from './components/PopoverBox'
// import RangeSlider from './components/RangeSlider'
import _ from 'lodash'

class Builder {
  constructor () {
    this.__popover = null
    this.__events = []
  }

  makeCustom (Popover) {
    this.__popover = Popover
    return this
  }

  makeListPopover () {
    this.__popover = ListPopover
    return this
  }

  makeOperator () {
    this.__popover = OperatorPopover
    return this
  }

  makeNotifiation () {
    this.__popover = NotificationPopover
    return this
  }

  makeSelect () {
    this.__popover = SelectPopover
    return this
  }

  addDefaultEvent () {
    this.addHandleScroll()
    this.addDismissOnOffClick()
    this.addDismiss()
    return this
  }

  addHandleScroll () {
    this.__events.push(E.handleScroll)
    return this
  }

  addHoverOver (el, areaIncludeHoverOver) {
    this.__events.push(E.hoverOver(el, areaIncludeHoverOver))
    return this
  }

  addDismiss () {
    this.__events.push(E.dismiss)
    return this
  }

  addDimissTimerForHover (el, areaIncludeHoverOver) {
    this.__events.push(E.dismissAfterXSecondsHover(el, areaIncludeHoverOver))
    return this
  }

  addDismissOnOffClick () {
    this.__events.push(E.dismissOnOffClick)
    return this
  }

  addDismissOnClickTimer (miliseconds) {
    this.__events.push(E.dismissOnClickTimer(miliseconds))
    return this
  }

  // need to add in the events
  // the events will be used to create the info
  get (options) {
    let el = document.createElement('div')
    el.style.overflow = 'hidden'
    document.body.appendChild(el)
    // this is how to add the mixins
    let cloned = _.cloneDeep(this.__popover)
    if (cloned.mixins) {
      cloned.mixins.push.apply(cloned.mixins, this.__events)
    } else {
      cloned.mixins = this.__events
    }
    const Popover = Vue.extend(cloned)
    const popoverBox = new Popover({
      el: el,
      propsData: {
        align: 'center',
        ...options
      }
    })
    return popoverBox
  }
}

export default Builder



// WEBPACK FOOTER //
// ./src/app/components/common/popover/builder.js